<template lang="">
  <div>
    <div id="footer">
      <div class="copyright" style="height:60px;">
        <a href="/" target="_blank" style="width: 176px;height: 44px;position: absolute;top: -5px;left: 0px;">
          <img :src="footerList.site_logo" style="width: 100%;">
        </a>
        <p>地址：{{footerList.company_address}} &nbsp;电话 :{{footerList.contact_phone}} &nbsp;传真 :{{footerList.company_fax}}
        </p>
        <p>Copyright 2024 ZHONGLEI GROUP. Power by oodow. <a target="_blank"
            href="https://beian.miit.gov.cn/">{{footerList.icp_number}}</a></p>
        <a href="http://www.sgs.gov.cn/lz/licenseLink.do?method=licenceView&amp;entyId=20120425131518271"
          target="_blank" style="width: 48px;height: 17px;position: absolute;top: 0px;left: 205px;">
          <img src="@/assets/images/icon.gif" border="0" alt="">
        </a>
        <div style="position:absolute;top:22px;right:195px;">
          <a href="http://tongji.baidu.com/hm-web/welcome/ico?s=3b1725d746099262ece3cd73cef2768b" target="_blank">
            <img border="0" src="https://hmcdn.baidu.com/static/hmt/icon/21.gif" width="20" height="20">
          </a>
        </div>
        <a href="http://www.zlqy.com.cn/" target="_blank" style="width: 176px;height: 44px;position: absolute;top: 5px;right: -20px;">
          <img :src="footerList.site_logo2" style="width: 100%;">
        </a>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        footerList: []
      }
    },
    mounted() {
      this.getFooter()
    },
    methods: {
      async getFooter() {
        const res = await this.$request.post('seo/getPaginate')
        if (res.data.code === 0) {
          this.footerList = res.data.data.data[0]
        }
      }
    },
  }
</script>
<style lang="css">
  .copyright a:last-child img {
    width: 100%;
  }

  .copyright p {
    padding-left: 90px;
  }
</style>